import { useContext, useEffect, useRef, useState } from "react"
import ActionGroup from "../compoents/ActionGroup"
import Rcslider from "../compoents/RcSlider"
import styles from "./index.module.scss"
import { ExtractionContext } from "../ExtractionContext"
import IconPaint from '@assets/images/extraction/icon_paint.svg';
import IconPaintActived from '@assets/images/extraction/icon_paint_actived.svg';
import IconErase from '@assets/images/extraction/icon_erase.svg';
import IconEraseActived from '@assets/images/extraction/icon_erase_actived.svg';
import IconAdd from '@assets/images/extraction/icon_add.svg'
import IconRemove from '@assets/images/extraction/icon_remove.svg';
import IconUndo from '@assets/images/extraction/icon_undo.svg'
import IconUndoActived from '@assets/images/extraction/icon_undo_actived.svg';
import IconReset from '@assets/images/extraction/icon_reset.svg'
import IconResetActived from '@assets/images/extraction/icon_reset_actived.svg';
import eventBus from '@utils/eventBus';
import { Button, Space, Upload } from "antd"
import { GenerateContext } from "@utils/GenerateContext"

function ExtractionHead(props) {
    const {
        inputImage, setInputImage,
        multiMasks, setMultiMasks,
        modelBlendedMask,
        setModelBlueMaskBase64,
        modelBlueMaskBase64OriginRef,
        interactiveMode, setInteractiveMode,
        paintMode, setPaintMode,
        paintSize, setPaintSize,
        eraseSize, setEraseSize,
        undoList, setUndoList,
        redoList, setRedoList,
        viewportOffset, setViewportOffset,
        moveable, setMoveable,
        zoom, setZoom,
    } = useContext(ExtractionContext)
    // const { drawType, modeState, paintSize, eraserSize } = useContext(GenerateContext)
    const generate = useContext(GenerateContext)


    useEffect(() => {
        if (props.loading) return
        if (generate.drawType == 'multi_add') {
            interactiveModeBackup.current = 'add'
            setInteractiveMode('add')
        } else if (generate.drawType == 'multi_reduce') {
            interactiveModeBackup.current = 'remove'
            setInteractiveMode('remove')
        } else if (generate.drawType == 'draw') {
            console.log('hahahaha')
            paintModeBackup.current = 'paint'
            setPaintMode('paint')
        }
    }, [generate.drawType, props.loading])


    // useEffect(() => {
    //     if (props.loading) return
    //     if(generate.drawType != 'draw') {
    //         setZoom(1)
    //         setMoveable()
    //         eventBus.emit(`image_extraction_reset_canvas_${props.uid}`)
    //     }
    // }, [generate.drawType, props.loading])

    useEffect(() => {
        if (generate.modeState == 'eraser') {
            paintModeBackup.current = 'erase'
            setPaintMode('erase')
        } else {
            paintModeBackup.current = generate.modeState
            setPaintMode(generate.modeState)
        }
        setPaintSize(generate.paintSize)
        setEraseSize(generate.eraserSize)
    }, [generate.modeState, generate.paintSize, generate.eraserSize])

    // 交互时分割模式 0-增加 1-减少
    const interactiveModeRef = useRef()
    useEffect(() => {
        interactiveModeRef.current = interactiveMode
        if (!interactiveMode) return
        setPaintMode()
        setMoveable(false)
    }, [interactiveMode])
    const interactiveItems = [{
        label: '增加选区1',
        icon: IconAdd,
        activedIcon: IconAdd,
        value: 'add',
        hover: false
    }, {
        label: '减少选区2',
        icon: IconRemove,
        activedIcon: IconRemove,
        value: 'remove',
        hover: false
    }]

    // 涂抹选项
    const paintModeRef = useRef()
    const paintSizeRef = useRef(20)
    const eraseSizeRef = useRef(20)
    useEffect(() => {
        paintModeRef.current = paintMode
        if (!paintMode) return
        setInteractiveMode()
        setMoveable(false)
    }, [paintMode])
    useEffect(() => {
        paintSizeRef.current = paintSize
        console.log('paintSize change', paintSize)
    }, [paintSize])
    useEffect(() => {
        eraseSizeRef.current = eraseSize
        console.log('eraseSize change', eraseSize)
    }, [eraseSize])
    const paintItems = [{
        label: '手动涂抹',
        icon: IconPaint,
        activedIcon: IconPaintActived,
        value: 'paint',
        hover: false,
        popover: (
            <Rcslider
                title={"画笔大小"}
                defaultValue={20}
                value={paintSize}
                onChange={setPaintSize}
                min={1}
                max={50}
                disabled={paintMode != 'paint'}
                type={'paint'}
            />
        )
    }, {
        label: '手动擦除',
        icon: IconErase,
        activedIcon: IconEraseActived,
        value: 'erase',
        hover: false,
        popover: (
            <Rcslider
                title={"橡皮大小"}
                defaultValue={20}
                value={eraseSize}
                onChange={setEraseSize}
                min={1}
                max={50}
                disabled={paintMode != 'erase'}
                type={'erase'}
            />
        )
    }]

    // 移动缩放控制
    const moveableRef = useRef()
    const zoomRef = useRef(1)
    const minZoomRef = useRef(.5)
    const maxZoomRef = useRef(10)
    const paintModeBackup = useRef() // paintMode备份，用于取消移动后恢复操作
    const interactiveModeBackup = useRef() // interactiveMode备份，用于取消移动后恢复操作
    useEffect(() => {
        moveableRef.current = moveable
     
        if (!moveable) {
            // setPaintMode(paintModeBackup.current)
            setInteractiveMode(interactiveModeBackup.current)
        } else {
            paintModeBackup.current = paintModeRef.current
            interactiveModeBackup.current = interactiveModeRef.current
            // setPaintMode()
            setInteractiveMode()
        }
    }, [moveable])
    useEffect(() => {
        zoomRef.current = zoom
    }, [zoom])
    const zoomOut = () => {
        setZoom(pre => {
            pre -= .1
            return Math.max(Math.min(pre, maxZoomRef.current), minZoomRef.current)
        })
    }
    const zoomIn = () => {
        setZoom(pre => {
            pre += .1
            return Math.max(Math.min(pre, maxZoomRef.current), minZoomRef.current)
        })
    }

    useEffect(() => {
        eventBus.on(`image_extraction_add_undo_${props.uid}`, addUndo)
        eventBus.on(`image_extraction_add_redo_${props.uid}`, addRedo)
        eventBus.on(`image_extraction_clear_redo_${props.uid}`, clearRedo)
        eventBus.on(`image_extraction_zoom_out_${props.uid}`, zoomOut)
        eventBus.on(`image_extraction_zoom_in_${props.uid}`, zoomIn)

        return () => {
            eventBus.off(`image_extraction_add_undo_${props.uid}`, addUndo)
            eventBus.off(`image_extraction_add_redo_${props.uid}`, addRedo)
            eventBus.off(`image_extraction_clear_redo_${props.uid}`, clearRedo)
            eventBus.off(`image_extraction_zoom_out_${props.uid}`, zoomOut)
            eventBus.off(`image_extraction_zoom_in_${props.uid}`, zoomIn)
        }
    }, [])

    // 其他操作
    const undoListRef = useRef([])
    const redoListRef = useRef([])
    const clearRedo = () => {
        redoListRef.current = []
        setRedoList(redoListRef.current)
    }
    const addUndo = (params) => {
        params = Object.assign(params, {
            interactiveMode: interactiveModeRef.current,
            paintMode: paintModeRef.current,
            paintSize: paintSizeRef.current,
            eraseSize: eraseSizeRef.current,
            moveable: moveableRef.current,
            zoom: zoomRef.current,
        })
        undoListRef.current = [...undoListRef.current, { params }]
        setUndoList(undoListRef.current)
    }
    const addRedo = (params) => {
        params = Object.assign(params, {
            interactiveMode: interactiveModeRef.current,
            paintMode: paintModeRef.current,
            paintSize: paintSizeRef.current,
            eraseSize: eraseSizeRef.current,
            moveable: moveableRef.current,
            zoom: zoomRef.current,
        })
        redoListRef.current = [...redoListRef.current, { params }]
        setRedoList(redoListRef.current)
    }
    const handleReset = async () => {
        setModelBlueMaskBase64(modelBlueMaskBase64OriginRef.current)
        // 重置按钮
        // interactiveModeBackup.current = null
        // paintModeBackup.current = null
        // setInteractiveMode()
        // setPaintMode()
        // setPaintSize(20)
        // setEraseSize(20)
        setMoveable()
        
        setZoom(1)
        // 重置canvas位置，清空canvas内容
        eventBus.emit(`image_extraction_reset_canvas_${props.uid}`)
        eventBus.emit(`image_extraction_clear_canvas_${props.uid}`)
        // 清空撤销和重置
        undoListRef.current = []
        setUndoList(undoListRef.current)
        redoListRef.current = []
        setRedoList(redoListRef.current)
       
    }


    const handleUndo = () => {
        if (undoListRef.current.length == 0) return
        const undo = undoListRef.current.pop()
        setUndoList(undoListRef.current)
        const {
            interactiveMode,
            paintMode,
            paintSize,
            eraseSize,
            moveable,
            zoom,
        } = undo.params
        setInteractiveMode(interactiveMode)
        setPaintMode(paintMode)
        setPaintSize(paintSize)
        setEraseSize(eraseSize)
        setMoveable(moveable)
        setZoom(zoom)
        // canvasRef.current.undoCanvas(undo)
        eventBus.emit(`image_extraction_undo_canvas_${props.uid}`, undo)
    }
    const handleRedo = () => {
        if (redoListRef.current.length == 0) return
        const redo = redoListRef.current.pop()
        setRedoList(redoListRef.current)
        const {
            interactiveMode,
            paintMode,
            paintSize,
            eraseSize,
            moveable,
            zoom,
        } = redo.params
        setInteractiveMode(interactiveMode)
        setPaintMode(paintMode)
        setPaintSize(paintSize)
        setEraseSize(eraseSize)
        setMoveable(moveable)
        setZoom(zoom)
        // canvasRef.current.redoCanvas(redo)
        eventBus.emit(`image_extraction_redo_canvas_${props.uid}`, redo)
    }
    const actionItems = [{
        label: '撤销',
        icon: IconUndo,
        activedIcon: IconUndoActived,
        value: 0,
        hover: false,
        disabled: undoList.length == 0,
        onClick: () => handleUndo()
    }, {
        label: '恢复',
        icon: IconUndo,
        activedIcon: IconUndoActived,
        iconStyle: { transform: 'rotateY(-180deg)' },
        value: 1,
        hover: false,
        disabled: redoList.length == 0,
        onClick: () => handleRedo()
    }, {
        label: '重置',
        icon: IconReset,
        activedIcon: IconResetActived,
        iconStyle: { transform: 'rotate3d(1, 1, 1, 15deg)' },
        value: 2,
        hover: false,
        onClick: () => handleReset()
    }]

    // 撤销操作                    
    function handleKeydown(event) {
        if (event.ctrlKey) {
            if (event.key == 'z') { // CTRL + Z
                handleUndo()
            }
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', handleKeydown);
        return () => {
            document.removeEventListener('keydown', handleKeydown);
        }
    }, [])

    

    const [loading, setLoading] = useState(false)
    const handleFinish = async () => {
        setLoading(true)
        await props.onFinish()
        setLoading(false)
    }

    const onUpload = (file) => {
        props.uploadCb(file)
        return false
    }

    return (
        <div className={styles.Container}>
            {/* <ActionGroup items={interactiveItems} value={interactiveMode} onChange={setInteractiveMode} /> */}
            {/* <ActionGroup items={paintItems} value={paintMode} onChange={setPaintMode} /> */}
            <ActionGroup items={actionItems} />
            <Space>
                {/* <Button onClick={props.onCancel}>取消修改</Button> */}
                {/* <Button loading={loading} type="primary" onClick={handleFinish}>完成修改</Button> */}
                <div className={styles.ReuploadBox}>
                    <Upload
                        accept='image/jpeg,image/png,image/webp,image/avif'
                        listType="picture-card"
                        className={styles.Uploader}
                        showUploadList={false}
                        beforeUpload={onUpload}
                    >
                        <div className={styles.up_btn}>重新上传</div>
                    </Upload>
                </div>
            </Space>
        </div>
    )
}

export default ExtractionHead